import React from "react";

export default function Spinner({ size = "md", color = "green" }) {
    const sizeClasses = {
        xs: "h-3 w-3",
        sm: "h-4 w-4",
        md: "h-5 w-5",
        lg: "h-6 w-6",
        xl: "h-8 w-8",
    };

    const colorClasses = {
        white: "border-white border-t-transparent",
        blue: "border-blue-600 border-t-transparent",
        gray: "border-gray-600 border-t-transparent",
        green: "border-green-600 border-t-transparent",
    };

    const sizeClass = sizeClasses[size] || sizeClasses.md;
    const colorClass = colorClasses[color] || colorClasses.white;

    return (
        <div
            className={`${sizeClass} ${colorClass} rounded-full border-2 animate-spin`}
            role="status"
            aria-label="Loading"
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
}











